import { render, staticRenderFns } from "./IncomeCard.vue?vue&type=template&id=1b3c5e4c&scoped=true&"
import script from "./IncomeCard.vue?vue&type=script&lang=js&"
export * from "./IncomeCard.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCard.vue?vue&type=style&index=0&id=1b3c5e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c5e4c",
  null
  
)

export default component.exports